import { TypeAlignEnum } from "@utils/index";

const DEFAULT_TEXT_ALIGN = TypeAlignEnum.LEFT;

export interface ITableBody {
  numberOrder?: string;
  subsidiary?: string;
  deliveryDate?: string;
  product?: string;
  quantity?: string;
  price?: string;
  paymentTerm?: string;
  payment?: string;
  atemStatus?: string;
  status?: string;
  implantationDate?: string;
}

export enum TKeyRequest {
  numberOrder = "numberOrder",
  subsidiary = "subsidiary",
  deliveryDate = "deliveryDate",
  product = "product",
  quantity = "quantity",
  price = "price",
  paymentTerm = "paymentTerm",
  atemStatus = "atemStatus",
}

export const HEAD_LABELS: Record<TKeyRequest, string> = {
  numberOrder: "Ordem",
  subsidiary: "Filial",
  deliveryDate: "Data de entrega",
  product: "Produto",
  quantity: "Quantidade",
  price: "Preço",
  paymentTerm: "Prazo",
  atemStatus: "Status",
};

const BASE_HEADERS = [
  { key: TKeyRequest.numberOrder },
  { key: TKeyRequest.subsidiary },
  { key: TKeyRequest.deliveryDate },
  { key: TKeyRequest.product },
  { key: TKeyRequest.quantity, unit: "(L)" },
  { key: TKeyRequest.price },
  { key: TKeyRequest.paymentTerm },
  { key: TKeyRequest.atemStatus },
];

const DEFAULT_ALIGN_BY_KEY: Partial<Record<TKeyRequest, TypeAlignEnum>> = {
  subsidiary: TypeAlignEnum.CENTER,
  deliveryDate: TypeAlignEnum.CENTER,
  product: TypeAlignEnum.CENTER,
  quantity: TypeAlignEnum.RIGHT,
  price: TypeAlignEnum.CENTER,
  paymentTerm: TypeAlignEnum.CENTER,
  atemStatus: TypeAlignEnum.CENTER,
};

export interface ITableHead {
  unit?: string;
  label: string;
  key: TKeyRequest;
  align?: TypeAlignEnum;
}

export const THeadData: ITableHead[] = BASE_HEADERS.map(({ key, unit }) => ({
  key,
  label: `${HEAD_LABELS[key]} ${unit ?? ""}`,
  unit,
  align: DEFAULT_ALIGN_BY_KEY[key] ?? DEFAULT_TEXT_ALIGN,
}));
